export function extractImageFromData(data, imageKey) {
  return data[imageKey] && data[imageKey].asset && data[imageKey].asset.gatsbyImageData && data[imageKey].asset.gatsbyImageData.images && data[imageKey].asset.gatsbyImageData.images.fallback ? data[imageKey].asset.gatsbyImageData.images.fallback.src : null;
}
